import { supabase } from '@/shared/lib/supabase';

export interface LandingLeadInput {
  nome: string;
  restaurante?: string;
  cidade?: string;
  whatsapp: string;
  num_telas?: number;
  mensagem?: string;
  origem?: string;
}

export async function enviarLandingLead(dados: LandingLeadInput): Promise<void> {
  const { error } = await supabase.from('landing_leads').insert({
    nome: dados.nome.trim(),
    restaurante: dados.restaurante?.trim() || null,
    cidade: dados.cidade?.trim() || null,
    whatsapp: dados.whatsapp.trim(),
    num_telas: dados.num_telas ?? null,
    mensagem: dados.mensagem?.trim() || null,
    origem: dados.origem ?? 'landing',
  } as never);

  if (error) throw error;
}
